import React from 'react';
import Typography from 'new/elements/Typography';
import { Stack } from '@mui/material';
import { Button } from 'new/elements/Button';
import { AddRounded } from '@mui/icons-material';
import { Section } from 'new/components/settings/VendorBuilder/components/Section';
import { useVendorBuilder } from 'new/components/settings/VendorBuilder/VendorBuilderContext';
import { Endpoint } from 'new/components/settings/VendorBuilder/Endpoints/Endpoint';

interface EndpointsProps {}

export const Endpoints = (props: EndpointsProps) => {
  const { vendor, onAddEndpoint, errors } = useVendorBuilder();

  const expanded = Object.keys(errors).some((error) => error.includes('endpoints'));

  return (
    <Section
      title={
        <>
          Endpoints [<code>vendor_endpoints</code>]
        </>
      }
      expanded={expanded || undefined}
      titleAcessory={
        <Typography variant="body2">Define endpoints to be used by the user.</Typography>
      }
      gap="16px"
    >
      <Typography variant="body2">
        This section defines endpoints for this vendor.
        <br />
        <strong>Recommendations</strong>:
        <ol>
          <li>Try to set atleast 2 endpoints for source & 2 for destination</li>
          <li>
            For Sources: Typically API vendors have a common pattern for fetching list of items.
            Instead of setting different endpoints for each object types, try using a resource
            parameter that allows picking item type to be fetched.
          </li>
          <li>
            For Sources: Pay attention to pagination rules. Try to set properties that reduce number
            of API calls Nexla will have to make for fetching all items.
          </li>
          <li>
            For Destinations: Same as sources, try to use a single dynamic endpoint for adding
            items.
          </li>
          <li>
            Remember that source endpoint params must start with <code>rest.iterations</code>, and
            destination endpoint params <strong>cannot</strong> start with{' '}
            <code>rest.iterations</code>
          </li>
        </ol>
      </Typography>
      {vendor.endpoints.map((endpoint, index) => {
        return <Endpoint index={index} key={index} />;
      })}
      <Stack alignItems="flex-start">
        <Button onClick={onAddEndpoint} startIcon={<AddRounded />}>
          Add endpoint
        </Button>
      </Stack>
    </Section>
  );
};
